export const DEFAULT_GL_THICKNESS_DECIMAL = '3.125'
export const DEFAULT_GL_THICKNESS_FRACTION = '3-1/8'

export const DEFAULT_EWP_THICKNESS_DECIMAL = '1.75'
export const DEFAULT_EWP_THICKNESS_FRACTION = '1-3/4'

const GLULAM_TYPE_VALUE = 'GL'

const determineNewDimensionValue = (
    isGL: boolean,
    shouldUseDecimalValue: boolean,
    defaultNonGLValueOverride?: string
) => {
    if (isGL) {
        return shouldUseDecimalValue ? DEFAULT_GL_THICKNESS_DECIMAL : DEFAULT_GL_THICKNESS_FRACTION
    }

    if (defaultNonGLValueOverride) return defaultNonGLValueOverride

    return shouldUseDecimalValue ? DEFAULT_EWP_THICKNESS_DECIMAL : DEFAULT_EWP_THICKNESS_FRACTION
}

const determineIfEWPDimensionShouldBeDecimal = (fieldDefaultValue: string) => {
    return fieldDefaultValue.includes('.')
}

export function determineEWPGLFlags(prevFormData: any, formData: any, ewpFieldName: string) {
    const isCurrentlyGL = formData[ewpFieldName] === GLULAM_TYPE_VALUE
    const isPreviousGL = prevFormData[ewpFieldName] === GLULAM_TYPE_VALUE

    const isGLChanging = isPreviousGL !== isCurrentlyGL

    return {
        isGLChanging,
        isCurrentlyGL,
    }
}

export function defaultFormDataOnEWPChange(
    formData: any,
    fieldDefaultValue: string,
    ewpDimensionFieldName: string,
    shouldUpdateEWPDefaultValue: boolean,
    isCurrentlyGL: boolean,
    ewpSubFieldName?: string,
    defaultNonGLValueOverride?: string
) {
    const shouldUseDecimalValue = determineIfEWPDimensionShouldBeDecimal(fieldDefaultValue)

    if (shouldUpdateEWPDefaultValue) {
        const newDimensionValue = determineNewDimensionValue(
            isCurrentlyGL,
            shouldUseDecimalValue,
            defaultNonGLValueOverride
        )

        if (!ewpSubFieldName) {
            formData[ewpDimensionFieldName] = newDimensionValue
        } else if (formData[ewpDimensionFieldName]) formData[ewpDimensionFieldName][ewpSubFieldName] = newDimensionValue
    }

    return formData
}
